<template>
  <div>
    <!-- <h4>Job Posting</h4> -->
    <!-- {{user}}
    <hr>
    {{ description }} -->

    <button class="mylisting-button dark-button" @click="showJobModal()">Post Job</button>

    <div v-for="job in jobs" :key="job.id">
      <!-- {{ job }} -->
      <h4 class="mt-3">{{ job.title }}<span v-if="job.status == 'Closed'"> (Closed)</span></h4>
      <p v-if="job.date">Start Date: {{ new Date(addCurrentTimeToDate(job.date)).toDateString() }}</p>
      <!-- <p>Schedule: {{ job.text }}</p> -->
      <p>Location: {{ job.city }}, {{ job.provincestate }}, {{ job.postal_code }}</p>
      <p>Compensation: {{ job.compensation }}</p>
      <p>Schedule: {{ job.text }}</p>
      <pre class="mt-2 mb-3" v-html="job.description"></pre>

      <!-- <button class="mylisting-button dark-button" v-if="job.status == 'Posted'" @click="broadcast(job)">Broadcast</button> -->
      <button class="mylisting-button dark-button" @click="showBroadcastModal(job)">Broadcast</button>
      <button class="mylisting-button dark-button" @click="showApplicantsModal(job)">View Applicants</button>

      <p class="mt-3" style="cursor: pointer;"><span @click="showJobModal(job)">Edit Job</span> | <span v-if="job.status == 'Closed'" @click="reopenJob(job)">Re-Open Job</span><span v-if="job.status != 'Closed'" @click="closeJob(job)">Close Job</span> | <span @click="showDeleteJobModal(job)">Delete</span></p>
      <!-- <p class="mt-3"><span @click="deleteJob(job)">Delete Job</span></p> -->
      <hr>
    </div>

    <modal name="job-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5 field-of-fields">
        <h3 v-if="job.id">Edit Job</h3>
        <h3 v-if="!job.id">Post Job</h3>
        <hr>
        <label style="margin-top: 0">Title</label>
        <input type="text" class="form-control" v-model="title">
        <label>City</label>
        <input type="text" class="form-control" v-model="city">
        <label>State</label>
        <input type="text" class="form-control" v-model="provincestate">
        <label>Zip Code</label>
        <input type="text" class="form-control" v-model="postalCode">
        <label>Compensation</label>
        <input type="text" class="form-control" v-model="compensation">
        <label>Start Date</label>
        <datepicker class="form-control" v-model="startDate" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
        <label>Schedule</label>
        <textarea rows="2" class="form-control" v-model="schedule"></textarea>
        <label>Description</label>
        <div class="editor">
          <!-- <Modal ref="ytmodal" @onConfirm="addCommand" /> -->
          <editor-menu-bar :editor="descriptionEditor" v-slot="{ commands, isActive }" class="mb-1">
            <div class="menubar">
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold">
                <strong>B</strong>
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic">
                <i>Italics</i>
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline">
                <u>U</u>
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
                Image
              </button> -->
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="uploadImage(commands.image)">
                Image
              </button> -->
              <!-- https://github.com/scrumpy/tiptap/issues/89 -->
              <!-- https://codesandbox.io/s/j3p0z44155 -->
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="openModal(commands.image);">
                Image
              </button> -->
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.paragraph() }" @click.prevent="commands.paragraph">
                p
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 2 })">
                H1
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click.prevent="commands.heading({ level: 3 })">
                H2
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click.prevent="commands.heading({ level: 4 })">
                H3
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list">
                List
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list">
                1. 2. 3...
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
                ""
              </button> -->
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.horizontal_rule() }" @click.prevent="commands.horizontal_rule">
                ---
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
                Undo
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
                Redo
              </button> -->
            </div>
          </editor-menu-bar>
          <editor-content class="editor__content" :editor="descriptionEditor" />
        </div>
        <hr>
        <button class="mylisting-button dark-button" v-if="!job.id" @click="postJob()">Save</button>
        <button class="mylisting-button dark-button" v-if="job.id" @click="patchJob(job)">Save</button>
      </div>
    </modal>
    <!-- <button class="mylisting-button dark-button mt-3" @click="save()">Save</button> -->

    <modal name="applicants-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <table class="table table-striped mt-2">
          <thead class="" style="background-color: var(--coredarkcolor); color: var(--corelightcolor);">
            <tr class="">
              <th scope="col">Name</th>
              <th scope="col">Application Date</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="application in applications" :key="application.id" style="cursor: pointer;">
              <td>
                {{ application.applicant_name }}
              </td>
              <td>
                <p>{{ new Date(application.date).toDateString() }}</p>
              </td>
              <td>
                {{ application.status }}
                <!-- <button class="btn btn-danger" @click="deleteApplication(application)">Delete</button> -->
              </td>
            </tr>
          </tbody>
        </table>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('applicants-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="notes-saved-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Notes saved!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('notes-saved-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="job-posted-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Job posted!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('job-posted-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="job-updated-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Job updated!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('job-updated-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="broadcast-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5 field-of-fields">
        <h3>Please select which candidates you would like to broadcast this to</h3>
        <hr>
        <!-- <div v-for="(candidate, index) in sortedCandidates" :key="'Candidate'+index">
          <h6 @click="selectCandidate(candidate)" style="cursor: pointer;">{{ candidate.first_name }} <span v-if="selectedCandidates.includes(candidate.id)"><i style="font-size: 15px;" class="material-icons mt-1">check_circle</i></span></h6>
        </div> -->
        <!-- {{ selectedCandidates }} -->
        <div>
          <button class="mylisting-button dark-button" @click="selectAllBroadcastCandidates()">Select All</button>
          <button class="mylisting-button dark-button" @click="deselectAllBroadcastCandidates()">Deselect All</button>
        </div>

        <p class="mt-3">Please note that applying a filter will deselect all candidates on the list.</p>
        <div class="row">
          <div class="col-lg-3 mt-2">
            <multiselect v-model="cityFilters" :options="$store.getters.cities" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by City"></multiselect>
            <!-- <multiselect v-model="statusFilters" :options="$store.getters.candidateStatuses" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Status"></multiselect> -->
          </div>
          <div class="col-lg-3 mt-2">

          </div>
          <div class="col-lg-3 mt-2">
            <!-- <div class="form-group form-check pt-1">
              <input class="form-check-input" type="checkbox" :value="true" v-model="hideRejected" style="margin-top: 4px;">
              <label class="form-check-label" style="text-align: left; cursor: pointer; margin-top: 0;" @click="hideRejected = !hideRejected">
                Hide Rejected Candidates
              </label>
            </div> -->
          </div>
          <div class="col-lg-3 mt-2">
            <!-- <button class="mylisting-button secondary-button" style="float: right;" @click="refresh()">Refresh</button> -->
          </div>

          <!-- <div class="col-lg-12 mt-2">
            <input type="text" class="form-control" v-model="nameSearch" placeholder="Search by Name or Email">
          </div> -->
        </div>
        <table class="table table-striped mt-3 mb-5">
          <thead class style="background-color: var(--coredarkcolor); color: #fff;">
            <tr class>
              <th scope="col"></th>
              <th scope="col">Name</th>
              <th scope="col">City</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="candidate in filteredCandidates" :key="'Broadcast list'+candidate.id">
              <td v-on:click.stop="">
                <div class="form-group form-check">
                  <input class="form-check-input" style="" type="checkbox" :value="candidate.id" v-model="selectedCandidates" >
                </div>
              </td>
              <td>{{ candidate.first_name }} {{ candidate.last_name }}</td>
              <td>{{ candidate.selector8 }}</td>
            </tr>
          </tbody>
        </table>
        <label>Any additional notes you'd like to add?</label>
        <textarea rows="3" v-model="broadcastNotes" class="form-control"></textarea>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('broadcast-modal')" style="">Close</button>
        <button v-if="selectedCandidates.length" class="mylisting-button dark-button" @click="broadcast()" style="float: right;">Broadcast</button>
      </div>
    </modal>

    <modal name="successfully-broadcasted-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <!-- <h2>Broadcast sent to {{ candidates.length }} nannies!</h2> -->
        <h2>Broadcast sent to {{ selectedCandidates.length }} nannies!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('successfully-broadcasted-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="delete-job-modal" width="75%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Are you sure you want to delete this job?</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-job-modal')" style="">Close</button>
        <button class="mylisting-button danger-button" style="float: right;" @click="deleteJob(job)">Delete</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
// import Icon from 'Components/Icon'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Image, // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
} from 'tiptap-extensions'

export default {
  props: ['user'],
  // props: ['userID'],
  components: {
    EditorContent,
    EditorMenuBar,
    Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data() {
    return {
      description: '',
      descriptionEditor: null,

      // user: {},
      candidates: [],
      jobs: [],
      job: {},
      title: '',
      startDate: null,
      city: '',
      provincestate: '',
      postalCode: '',
      compensation: '',
      schedule: '',

      applications: [],

      selectedCandidates: [],
      broadcastNotes: '',
      cityFilters: [],
    }
  },
  mounted() {
    this.descriptionEditor = new Editor({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3, 4, 5] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new Image(), // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
      ],
      onUpdate: ({ getJSON, getHTML }) => {
        // this.json = getJSON()
        // this.html = getHTML()
        this.description = getHTML()
      },
    })

    // if (this.user.richtext1) {
    //   this.descriptionEditor.setContent(this.user.richtext1)
    // }
    // else {
    //   this.descriptionEditor.setContent(
    //     '<h5>1. Family Name</h5><p></p><hr>\
    //     <h5>2. Family Address</h5><p></p><hr>\
    //     <h5>3. Mom’s full name / occupation /cell # /work # / email</h5><p></p><hr>\
    //     <h5>4. Dad’s full name  / occupation /cell # /work # / email</h5><p></p><hr>\
    //     <h5>5. Children’s Full Name & Birthday</h5><p></p><hr>\
    //     <h5>6. Allergies / Special Needs regarding the children</h5><p></p><hr>\
    //     <h5>7. Pets (kind – temperament – indoor/outdoor – care needed)</h5><p></p><hr>\
    //     <h5>8. Children’s interests/hobbies</h5><p></p><hr>\
    //     <h5>9. Behaviour modification strategies</h5><p></p><hr>\
    //     <h5>10. Emergency contact (name, relation & number)</h5><p></p><hr>\
    //     <h5>11. Days & Times required</h5><p></p><hr>\
    //     <h5>12. Start day/end day (contract duration)</h5><p></p><hr>\
    //     <h5>13. Driver’s license/vehicle required?</h5><p></p><hr>\
    //     <h5>14. Open to the Nanny taking the children to activities?</h5><p></p><hr>\
    //     <h5>15. Car Seats provided?</h5><p></p><hr>\
    //     <h5>16. Expectations for your Nanny</h5><p></p><hr>\
    //     <h5>17. Daily Routine for the Nanny</h5><p></p><hr>\
    //     <h5>Process going forward: </h5><p>Medical Release & Transportation Consent must be completed prior to the first shift</p><p>Client to email dates and times – 1-2 weeks in advance</p><p></p><hr>\
    //     <h5>TNC</h5><p>Communication Log to be completed & sent with first shift</p><p>Once the shift is filled send the NOC profile to client</p><p>Build the NOC Family spec sheet – send to Nanny </p><p></p><hr>\
    //     '
    //   )
    // }

    // this.getUser()
  },
  beforeDestroy() {
    this.descriptionEditor.destroy()
  },
  created() {
    // if (this.user.richtext1) {
    //   this.descriptionEditor.setContent(this.user.richtext1)
    // }
    // else {
    //   this.descriptionEditor.setContent(
    //     '<h4>1. Family Name</h4><p></p><hr>\
    //     '
    //   )
    // }

    this.getJobs()
    this.getCandidates()
  },
  computed: {
    filteredCandidates() {
      let filteredCandidates = this.candidates

      filteredCandidates = filteredCandidates.filter(candidate => {
        return this.$store.getters.broadcastStatuses.includes(candidate.status)
      })

      if (this.cityFilters.length) {
        this.deselectAllBroadcastCandidates() // Want to reset all selections when applying a filter
        filteredCandidates = filteredCandidates.filter(candidate => {
          return this.cityFilters.includes(candidate.selector8)
        })
      }

      return filteredCandidates
    }
  },
  methods: {
    // getUser() {
    //   // https://www.npmjs.com/package/vue-loading-overlay
    //   let loader = this.$loading.show({
    //     // Optional parameters
    //     container: this.fullPage ? null : this.$refs.formContainer,
    //     // container: this.$refs.formContainer,
    //     // canCancel: true,
    //     canCancel: false,
    //     // onCancel: this.onCancel,
    //   });
    //   // simulate AJAX
    //   setTimeout(() => {
    //     loader.hide()
    //   },2000)

    //   axios.get(`/api/people/?id=${this.userID}`)
    //     .then(res => {
    //       this.user = res.data[0]

    //       if (this.user.richtext1) {
    //         this.descriptionEditor.setContent(this.user.richtext1)
    //       }
    //       else {
    //         this.descriptionEditor.setContent(
    //           '\
    //           '
    //         )
    //       }
    //     })
    // },
    // save() {
    //   axios.patch(`/api/people/${this.user.id}/`, {
    //     richtext1: this.description
    //   })
    //     .then(res => {
    //         console.log(res)
    //         this.getUser()
    //         this.$modal.show('notes-saved-modal')
    //       })
    //       .catch(error => console.log(error))
    // }
    getJobs() {
      axios.get(`/api/jobs/?poster=${this.user.id}`)
        .then(res => {
          console.log(res.data)
          // if (res.data.length) { // If the job already

          // }
          this.jobs = res.data
          this.jobs = this.jobs.sort((a, b) => (a.id < b.id) ? 1 : -1)
        })
        .catch(error => console.log(error))
    },
    showJobModal(job) {
      if (job) {
        this.job = job
        this.title = job.title
        this.city = job.city
        this.provincestate = job.provincestate
        this.postalCode = job.postal_code
        if (job.date) {
          this.startDate = new Date(this.addCurrentTimeToDate(job.date))
        }
        this.schedule = job.text
        this.compensation = job.compensation
        this.descriptionEditor.setContent(this.user.description)
      }
      else {
        this.job = {}
        this.title = ''
        this.startDate = null
        this.city = this.user.city
        this.provincestate = this.user.provincestate
        this.postalCode = this.user.postal_code
        this.compensation = ''
        this.schedule = ''
        this.descriptionEditor.setContent('')
      }
      this.$modal.show('job-modal')
    },
    postJob() {
      if (this.startDate) {
        this.startDate = this.dateInDjangoFormat(this.startDate)
      }

      axios.post(`/api/jobs/`, {
        poster: this.user.id,
        poster_name: `${this.user.first_name} ${this.user.last_name}`,
        title: this.title,
        city: this.city,
        provincestate: this.provincestate,
        postal_code: this.postalCode,
        status: 'Posted',
        date: this.startDate,
        compensation: this.compensation,
        text: this.schedule,
        description: this.description,
        job_type: "Long Term",
        agency: this.$store.getters.agencyID,
        agency_owner: this.$store.getters.agencyName
      })
        .then(res => {
          this.$modal.hide('job-modal')
          this.$modal.show('job-posted-modal')
          this.getJobs()
        })
        .catch(error => console.log(error))
    },
    patchJob(job) {
      if (this.startDate) {
        this.startDate = this.dateInDjangoFormat(this.startDate)
      }

      axios.patch(`/api/jobs/${job.id}/`, {
        // poster: this.user.id,
        // poster_name: `${this.user.first_name} ${this.user.last_name}`,
        title: this.title,
        city: this.city,
        provincestate: this.provincestate,
        postal_code: this.postalCode,
        // status: 'Posted',
        date: this.startDate,
        compensation: this.compensation,
        text: this.schedule,
        description: this.description,
        job_type: "Long Term",
        // agency: this.$store.getters.agencyID,
        // agency_owner: this.$store.getters.agencyName
      })
        .then(res => {
          this.$modal.hide('job-modal')
          this.$modal.show('job-updated-modal')
          this.getJobs()
        })
        .catch(error => console.log(error))
    },
    showApplicantsModal(job) {
      this.getApplications(job)
      this.$modal.show('applicants-modal')
    },
    getApplications(job) {
      axios.get(`/api/jobapplications/?job=${job.id}`)
        .then(res => {
          console.log(res)
          this.applications = res.data

          // this.$modal.show('job-modal')
        })
        .catch(error => console.log(error))
    },
    refreshApplications() {
      this.getApplications(this.job)
    },
    getCandidates() {
      // axios.get(`/api/people/?agency=${this.$store.getters.agencyID}&is_candidate=true&status=${this.$store.getters.activeStatus}`)
      axios.get(`/api/people/?agency=${this.$store.getters.agencyID}&is_candidate=true`)
        .then(res => {
          this.candidates = res.data;
          // console.log("Candidates", this.candidates);
          // this.candidateEmails = this.candidates.map(
          //   candidate => `${candidate.first_name} ${candidate.last_name} (${candidate.email})`
          // );

          this.candidates = this.candidates.filter(candidate => {
            return this.$store.getters.broadcastStatuses.includes(candidate.status)
          })
        })
        .catch(error => console.log(error));
    },
    // broadcast() {
    //   // Send out the notification
    //   for (var candidate in this.selectedCandidates) {
    //     console.log(this.selectedCandidates[candidate])
    //     axios.post(`/api/jobapplications/`, {
    //       applicant: this.selectedCandidates[candidate].id,
    //       applicant_name: `${this.selectedCandidates[candidate].first_name} ${this.selectedCandidates[candidate].last_name}`,
    //       job: this.job.id,
    //       job_title: this.job.poster_name,
    //       status: 'No Response',
    //       agency_owner: this.$store.getters.agencyName,
    //       agency: this.$store.getters.agencyID,
    //     })
    //       .then(res => {
    //         // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
    //         let selectedCandidate = this.selectedCandidates.filter(user => user.id == res.data.applicant)[0]
    //         console.log(selectedCandidate)

    //         // if (this.selectedCandidates[candidate].preferences3.includes('Email')) { // If the candidate wants to be notified via email
    //         if (selectedCandidate.preferences3.includes('Email')) { // If the candidate wants to be notified via email
    //           this.$store.dispatch('sendEmail',
    //             {
    //               subject: `New Opportunity ${new Date(this.addCurrentTimeToDate(this.job.date)).toDateString()}, ${this.djangotimeformatAMPM(this.job.start_time)} - ${this.djangotimeformatAMPM(this.job.end_time)}`,
    //               // message: 'Hello ' + this.selectedCandidates[candidate].first_name + ',\n\n' +
    //               message: 'Hello ' + selectedCandidate.first_name + ',\n\n' +
    //               'A family has posted a request for a nanny that you might be interested in!\n' +
    //               // `To see all the details please go to localhost:8080/job/${this.job.id} \n\n` +
    //               `To see all the details please go to https://goldcoastnannies.enginehire.io/job/${this.job.id} \n\n` +
    //               `Date: ${new Date(this.addCurrentTimeToDate(this.job.date)).toDateString()}\n` +
    //               `Start Time: ${this.djangotimeformatAMPM(this.job.start_time)}\n` +
    //               `End Time: ${this.djangotimeformatAMPM(this.job.end_time)}\n\n` +
    //               'Even if you are not interested we would really appreciate it if you could go to the link to let us know!\n\n' +
    //               'Thanks!\n'+
    //               'The Nanny Company Team',
    //               from: this.$store.getters.agencyFromEmail,
    //               // email: this.selectedCandidates[candidate].email,
    //               email: selectedCandidate.email,
    //               reply: this.$store.getters.agencyReplyEmail,
    //               // userID: this.aakashid,
    //               // userID: this.selectedCandidates[candidate].id,
    //               userID: selectedCandidate.id,
    //             }
    //           )
    //         }

    //         // Increment the counter for the number of broadcasts this candidate has received
    //         // let statsArray = this.selectedCandidates[candidate].numberArray
    //         let statsArray = selectedCandidate.numberArray
    //         // console.log(statsArray)
    //         statsArray[0] += 1
    //         // console.log(statsArray)
    //         // axios.patch(`/api/people/${this.selectedCandidates[candidate].id}/`, {
    //         axios.patch(`/api/people/${selectedCandidate.id}/`, {
    //           numberArray: statsArray
    //         })
    //           .catch(error => console.log(error))

    //         if (candidate == (this.selectedCandidates.length - 1)) { // If we just processed the last candidate in the list
    //           this.getApplications(this.job)
    //           this.$modal.show('successfully-broadcasted-modal')
    //           this.$modal.hide('broadcast-modal')

    //           axios.patch(`/api/jobs/${this.job.id}/`, {
    //             status: 'Pending',
    //           })
    //             .then(res => {
    //               console.log(res)
    //               this.job.status = 'Pending'
    //               this.status = 'Pending'
    //             })
    //             .catch(error => console.log(error))
    //         }
    //       })
    //       .catch(error => console.log(error))
    //   }
    //   // this.$modal.show('successfully-broadcasted-modal')
    //   // this.$modal.hide('broadcast-modal')
    // },
    showBroadcastModal(job) {
      // this.getCandidates()
      this.job = job
      this.selectedCandidates = []
      this.$modal.show('broadcast-modal')
    },
    selectAllBroadcastCandidates() {
      this.selectedCandidates = []
      for (var candidate in this.filteredCandidates) {
        this.selectedCandidates.push(this.filteredCandidates[candidate].id)
      }
    },
    deselectAllBroadcastCandidates() {
      this.selectedCandidates = []
    },
    broadcast(job) {
      console.log('Broadcasting')
      // console.log(this.candidates.length())

      // Send out the notification
      // for (var candidate in this.candidates) {
      //   this.$store.dispatch('sendEmail',
      //     {
      //       subject: `New Opportunity - ${job.title}`,
      //       message: 'Hello ' + this.candidates[candidate].first_name + ',\n\n' +
      //       'A family has posted a request for a nanny that you might be interested in!\n' +
      //       // `To see all the details please go to localhost:8080/job/${this.job.id} \n\n` +
      //       `To see all the details please go to https://goldcoastnannies.enginehire.io/job/${job.id} \n\n` +
      //       // `Start Date: ${new Date(this.addCurrentTimeToDate(job.date)).toDateString()}\n` +
      //       `Location: ${job.city}, ${job.provincestate}, ${job.postal_code}\n` +
      //       `Compensation: ${job.compensation}\n` +
      //       `Schedule: ${job.text}\n\n` +
      //       // `Description: ${job.description}\n` +
      //       'Even if you are not interested we would really appreciate it if you could go to the link to let us know!\n\n' +
      //       'Thanks,\n'+
      //       'The Coast to Coast Nannies Team',
      //       from: this.$store.getters.agencyFromEmail,
      //       email: this.candidates[candidate].email,
      //       reply: this.$store.getters.agencyReplyEmail,
      //       userID: this.candidates[candidate].id,
      //     }
      //   )
      // }
      for (var id in this.selectedCandidates) {

        // selectedCandidates holds a list of IDs, we want to get the corresponding candidate
        let candidate = this.candidates.filter(candidate => {
          return candidate.id == this.selectedCandidates[id]
        })[0]

        console.log(candidate)

        this.$store.dispatch('sendEmail',
          {
            subject: `New Opportunity - ${this.job.title}`,
            message: 'Hi ' + candidate.first_name + ',\n\n' +
            'A family has posted a request for a nanny that you might be interested in!\n' +
            `To see all the details please go to ${this.$store.getters.platformURL}job/${this.job.id} \n\n` +
            `Location: ${this.job.city}, ${this.job.provincestate}, ${this.job.postal_code}\n` +
            `Compensation: ${this.job.compensation}\n` +
            `Schedule: ${this.job.text}\n\n` +
            `Additional Notes: ${this.broadcastNotes} \n\n` +
            'If you are interested please go to the link to let us know!\n\n' +
            'Thanks!\n'+
            `The ${this.$store.getters.agencyHumanName} Team`,
            from: this.$store.getters.agencyFromEmail,
            email: candidate.email,
            reply: this.$store.getters.agencyReplyEmail,
            userID: candidate.id,
          }
        )
      }

      // if (candidate == (this.candidates.length - 1)) { // If we just processed the last candidate in the list
      if (id == (this.selectedCandidates.length - 1)) { // If we just processed the last candidate in the list
        // this.getApplications(this.job)
        this.$modal.show('successfully-broadcasted-modal')
        // this.$modal.hide('broadcast-modal')

        axios.patch(`/api/jobs/${this.job.id}/`, {
          status: 'Broadcasted',
        })
          .then(res => {
            console.log(res)
            // this.job.status = 'Pending'
            // this.status = 'Pending'
            this.getJobs()
          })
          .catch(error => console.log(error))
      }
    },
    closeJob(job) {
      axios.patch(`/api/jobs/${job.id}/`, {
        status: 'Closed',
      })
        .then(res => {
          console.log(res)
          // this.job.status = 'Pending'
          // this.status = 'Pending'
          this.getJobs()
        })
        .catch(error => console.log(error))
    },
    reopenJob(job) {
      axios.patch(`/api/jobs/${job.id}/`, {
        status: 'Posted',
      })
        .then(res => {
          console.log(res)
          // this.job.status = 'Pending'
          // this.status = 'Pending'
          this.getJobs()
        })
        .catch(error => console.log(error))
    },
    showDeleteJobModal(job) {
      this.job = job
      this.$modal.show('delete-job-modal')
    },
    deleteJob() {
      axios.delete(`/api/jobs/${this.job.id}`)
        .then(res => {
          console.log(res)
          this.getJobs()
          // this.$modal.hide('job-modal')
          this.$modal.hide('delete-job-modal')
        })
        .catch(error => {
          console.log(error)
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/functions/JobPosting.vue